import { ApplicationConfig, provideZoneChangeDetection, LOCALE_ID, provideAppInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { authInterceptorFn } from './core/interceptors/auth.interceptor';
import { errorInterceptorFn } from './core/interceptors/error.interceptor';
import { AuthService } from './features/auth/services/auth.service';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([
        authInterceptorFn,
        errorInterceptorFn
      ])
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark',
          cssLayer: false
        }
      }
    }),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      authService.initializeTokenTimer();
    })
  ]
};
